import { 
  GET_EXTERNAL_CALLS_FAILURE,
  GET_EXTERNAL_CALLS_REQUEST, 
  GET_EXTERNAL_CALLS_SUCCESS, 
  GetExternalCallsActionTypes, 
  GetExternalCallsState 
} from './types';

const defaultState: GetExternalCallsState = {
  isLoading: false,
  errorMessage: "",
};

export default function getExternalCalls(state = defaultState, action: GetExternalCallsActionTypes): GetExternalCallsState {
  switch (action.type) {
    case GET_EXTERNAL_CALLS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_EXTERNAL_CALLS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_EXTERNAL_CALLS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
